import { render, staticRenderFns } from "./ServerPorts.vue?vue&type=template&id=2454f651&scoped=true&"
import script from "./ServerPorts.vue?vue&type=script&lang=js&"
export * from "./ServerPorts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2454f651",
  null
  
)

export default component.exports